"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyPpConfiguration = void 0;
const common_1 = require("../common");
const getEmptyPpConfiguration = () => {
    return {
        __type: "PreviewPageConfiguration",
        version: 7,
        retention: common_1.PageRetention.MONTH,
        video: {
            url: "",
            name: ""
        },
        playerConfiguration: {
            posterImage: {
                url: "",
                platformId: ""
            },
            analyticsToken: "",
            showLogo: true,
            playButtonColor: "black",
            addTranscriptButton: true,
            lockPlayerBar: true,
            ccOnByDefault: false,
            largeCenterPlayIcon: false,
            rectangleCenterPlayIcon: false,
            logoOverlay: {
                url: "",
                platformId: "",
                displayLogo: false
            },
            aspectRatio: "horizontal"
        },
        content: {
            status: "pending"
        },
        trackingAccountId: null,
        trackingAccountName: null,
        trackingVideoId: null,
        trigger: "Review link"
    };
};
exports.getEmptyPpConfiguration = getEmptyPpConfiguration;
//# sourceMappingURL=emptyConfiguration.js.map